
import React from 'react';
import Layout from '@/components/Layout/Layout';
import BodyFatCalculator from '@/components/SpecialCalculators/HealthCalculators/BodyFatCalculator';

const BodyFatCalculatorPage = () => {
  return (
    <Layout>
      <div className="max-w-5xl mx-auto">
        <h1 className="text-3xl font-bold mb-2">Body Fat Calculator</h1>
        <p className="text-gray-600 mb-8">
          Calculate your body fat percentage using different measurement methods.
        </p>
        
        <BodyFatCalculator />
        
        <div className="mt-12 p-6 bg-blue-50 rounded-lg">
          <h2 className="text-xl font-bold mb-2">About Body Fat Calculator</h2>
          <p className="text-gray-700 mb-4">
            This body fat calculator helps you estimate your body fat percentage using three different methods:
          </p>
          <ul className="list-disc pl-6 space-y-1 text-gray-700">
            <li><strong>Navy Method:</strong> Uses neck, waist, and hip measurements</li>
            <li><strong>BMI Method:</strong> Uses BMI to estimate body fat (less accurate)</li>
            <li><strong>Skinfold Method:</strong> Uses caliper measurements (most accurate when done properly)</li>
          </ul>
          <p className="mt-4 text-gray-700">
            Body fat percentage is a better indicator of health than weight alone, as it distinguishes between fat mass and lean body mass.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default BodyFatCalculatorPage;
